import { useQueries, useQuery } from "@tanstack/react-query";

import { UserRetrieveRequest } from "@nens/rana/api-v1";
import { getRanaApiV1 } from "@nens/rana/api-v1";

// Single

export const getUserQuery = (userId: string | undefined) => {
  return getRanaApiV1().getQueryOptions({
    queryKey: ["user-detail", userId],
    queryFn: async () => {
      if (!userId) throw Error("Never happens");
      return await getRanaApiV1().UsersApi.userRetrieve({ id: userId });
    },
    enabled: !!userId,
  });
};

export const useGetUserQuery = () => {
  return getUserQuery;
};

export const useUserQuery = (userId: string | undefined) => {
  return useQuery(getUserQuery(userId));
};

const getUserQueryWithTenantId = (userId: string | undefined, tenantId: string | undefined) => {
  const { ...query } = getUserQuery(userId);
  // Replace index 1 with tenantId, keep the rest
  const newQueryKey = [...query.queryKey];
  newQueryKey[1] = tenantId;
  query.queryKey = newQueryKey;

  return {
    ...query,
    queryFn: async () => {
      if (!userId || !tenantId) throw Error("Never happens");
      const userRetrieve: UserRetrieveRequest = {
        tenantId,
        id: userId,
      };
      return await getRanaApiV1().UsersApi.userRetrieve(userRetrieve);
    },
    enabled: !!userId && !!tenantId,
  };
};

export const useUserQueriesWithTenantId = (userId: string, tenantIds: string[]) => {
  return useQueries({
    queries: tenantIds.map((tenantId) => getUserQueryWithTenantId(userId, tenantId)),
  });
};
